import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InspectionTimeCase } from '@authority-labs/api-interfaces';
import { CheckBasicCaseComponent } from '../check-basic-case/check-basic-case.component';
@Component({
  selector: 'authority-labs-check-time-case',
  templateUrl: './check-time-case.component.html',
  styleUrls: ['./check-time-case.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckTimeCaseComponent extends CheckBasicCaseComponent {
  @Input() inspection: InspectionTimeCase;
}
